import Component from './HostingEarnings'

export default Component
